import React from "react";

const travelOptions = [
  {
    title: "Direct Cab (Recommended)",
    icon: "🚕",
    description:
      "The most convenient option, especially for first-time visitors and travelers carrying luggage.",
    details: [
      "Available: Uber, Ola, Rapido, Airport Taxi",
      "Distance: 50–55 km",
      "Travel Time: 60–90 minutes",
      "Approx. Fare: ₹800–₹1,500",
    ],
  },
  {
    title: "Metro Route (Budget Friendly)",
    icon: "🚇",
    description:
      "The most economical way to reach Sharda University from the airport.",
    details: [
      "Airport Express Line → New Delhi Metro Station",
      "Yellow Line → Rajiv Chowk",
      "Blue Line → Noida Sector 52",
      "Walk to Sector 51 Aqua Line Station",
      "Aqua Line → Knowledge Park II",
      "Auto/E-rickshaw to Sharda University",
      "Travel Time: 2–2.5 Hours",
      "Approx. Cost: ₹100–₹200",
    ],
  },
  {
    title: "Airport → Kashmere Gate → Greater Noida",
    icon: "🚌",
    description:
      "Suitable for travelers preferring public transport and intercity buses.",
    details: [
      "Airport to Kashmere Gate",
      "Bus to Pari Chowk / Greater Noida",
      "Auto to Sharda University",
      "Low-cost option",
    ],
  },
  {
    title: "Metro + Auto",
    icon: "🚖",
    description: "A balanced option combining affordability and convenience.",
    details: [
      "Airport Metro → Knowledge Park II",
      "Shared Auto/E-rickshaw → Sharda University",
      "Auto Fare: ₹20–₹50",
      "Popular among students and delegates",
    ],
  },
];

const TravelPage = () => {
  return (
    <div className="bg-gray-50 min-h-screen py-24 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-14">
          <h1 className="text-4xl md:text-5xl font-bold text-indigo-900 mb-4">
            Travel Information
          </h1>
          <p className="text-gray-600 max-w-3xl mx-auto">
            Sharda University is located in Knowledge Park III, Greater Noida.
            Visitors can reach the campus conveniently via cab, metro, bus, or a
            combination of public transport options.
          </p>
        </div>

        {/* Airport Section */}
        <div className="bg-white rounded-2xl shadow-md p-8 mb-12">
          <h2 className="text-2xl font-bold text-indigo-800 mb-4">
            From Indira Gandhi International Airport (IGI), Delhi
          </h2>

          <p className="text-gray-700 leading-relaxed">
            The university is approximately 50–55 km from IGI Airport. Depending
            on your budget and convenience, you may choose any of the travel
            options listed below.
          </p>
        </div>

        {/* Travel Options */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {travelOptions.map((option, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 p-6"
            >
              <div className="flex items-center gap-4 mb-4">
                <span className="text-4xl">{option.icon}</span>
                <h3 className="text-xl font-bold text-indigo-900">
                  {option.title}
                </h3>
              </div>

              <p className="text-gray-600 mb-4">{option.description}</p>

              <ul className="space-y-2">
                {option.details.map((detail, idx) => (
                  <li
                    key={idx}
                    className="flex items-start gap-2 text-gray-700"
                  >
                    <span className="text-green-600 mt-1">✓</span>
                    <span>{detail}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Kashmere Gate Section */}

        <div className="bg-white rounded-2xl shadow-md p-8 mb-12 mt-20">
          <h2 className="text-2xl font-bold text-indigo-800 mb-4">
            From Kashmere Gate ISBT (Bus Stand), Delhi
          </h2>

          <div className="space-y-3 text-gray-700">
            <p>
              <strong>Step 1:</strong> Walk to Kashmere Gate Metro Station.
            </p>

            <p>
              <strong>Step 2:</strong> Take the Yellow Line and travel to Rajiv
              Chowk.
            </p>

            <p>
              <strong>Step 3:</strong> Change to the Blue Line towards Noida
              Electronic City and get down at Noida Sector 52.
            </p>

            <p>
              <strong>Step 4:</strong> Walk to Sector 51 Aqua Line Station.
            </p>

            <p>
              <strong>Step 5:</strong> Board the Aqua Line and get down at
              Knowledge Park II Metro Station.
            </p>

            <p>
              <strong>Step 6:</strong> Take an auto/e-rickshaw to Sharda
              University.
            </p>

            <div className="mt-4 p-4 bg-indigo-50 rounded-lg">
              <p>
                <strong>Total Travel Time:</strong> Approximately 1.5–2 hours
              </p>
              <p>
                <strong>Approximate Metro Fare:</strong> ₹60–₹100
              </p>
              <p>
                <strong>Nearest Metro Station:</strong> Knowledge Park II
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelPage;
